const server = {
  local: {
    //admin: '//jpjs.geeker.com.cn/'
    //admin: '//172.16.12.34:8080/scenic/'
    admin: '//10.255.255.189:8081/'
  },
  dev: {
     admin: '//jpjs.geeker.com.cn/'
    //admin: '//jpjstest.geeker.com.cn/'
    // admin: '//192.168.1.3:8080/'
    // admin: '//guide.jinpaijieshuo.com/'
  },
  pro: {
    admin: '//jpjs.geeker.com.cn/'
    //admin: '//jpjs.geeker.com.cn/'
  }
}
export default server



// WEBPACK FOOTER //
// ./src/config/server.js